import React, { Component } from 'react';

//views
import CariAppFormContainer0 from "../../../cari_app_form_view/container/CariAppFormContainerPg0";
import CariMainPgLoggedInHeaderView from "../../../cari_template_view/CariMainPgLoggedInHeaderView";

//generic functions
import {
    isEmpty
} from "../../../../../../functions/generic_functions";

//redux
import { connect } from "react-redux";

//redux mapper
const mapStateToProps = state => {
    return {
        activePositionData: state.cariReducer.activePositionData
    };
};

class CariAppFormConsentLayout extends Component {

    constructor(Props) {
        super(Props);

        //set active position
        this.getActivePositionDataFromStore = this.getActivePositionDataFromStore.bind(this);
    }

    componentDidMount() {
        document.title = this.getActivePositionDataFromStore().position_title + " consent";
    }

    //get active position data from redux store
    getActivePositionDataFromStore() {
        var copyPositionData = this.props.activePositionData;

        if (!isEmpty(copyPositionData)) {
            return copyPositionData;
        }
        else {
            return { "position_id": null, "position_title": "Position Title" }
        }
    }

    render() {
        return (
            <div>
                <div className="p-grid">
                    <div className="p-col-12 layout_header_view">
                        <CariMainPgLoggedInHeaderView
                            siteTitle={this.props.siteTitle}
                        /> 
                    </div>
                </div> 
                <div className="p-grid">
                    <div className="p-col-12 layout_left_right_padding">
                        <br />
                        <label className="cari_title">
                            {this.getActivePositionDataFromStore().position_title}
                        </label>
                        <br/>

                        <CariAppFormContainer0
                            match={this.props.match}
                        />
 
                    </div>
                </div>
            </div>
        );
    }
}
export default connect(mapStateToProps)(CariAppFormConsentLayout);